// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-label[data-v-193d7170]{background:#e1f3d8}.pages[data-v-193d7170] .el-dialog{max-width:95%!important;max-height:98%!important}", ""]);
// Exports
module.exports = exports;
